import { IdtComponent } from 'shared/models/idt-components/idt-component.models';


export function getWysiwygAligmentClasses(component: IdtComponent | undefined) {
  const classes: string[] = [];

  if (isDefined(component) && isDefined(component.settings)) {
    if (component.settings.styles.textPositionVertical) {
      classes.push(`vertical-${component.settings.styles.textPositionVertical}`);
    }
  }

  return classes.join(' ');
}

export type TypeOfVideo = 'own' | 'youtube' | 'vimeo';
export type TypePositionOfAudioIcon = 'top-left' | 'top-center' | 'top-right' | 'center-left' | 'center-center' | 'center-right' | 'bottom-left' | 'bottom-center' | 'bottom-right' | 'top-text' | 'bottom-text';

